export function mergeArraysWithoutDuplicates(array1, array2) {
  if (!array1 && !array2) {
    return []
  }

  const mergeArray = []
  if (array1) {
    mergeArray.push(...array1)
  }
  if (array2) {
    mergeArray.push(...array2)
  }
  return [...new Set([...mergeArray])]
}

export function removeKeyFromState(state, keyToRemove) {
  const { [keyToRemove]: _, ...newState } = state
  return newState
}

export function removeKeyFromStateCascade(state, parentKey, keyToRemove) {
  if (!state[parentKey]) return state

  const keys = Object.keys(state[parentKey])
  if (keys.length === 1 && keys[0] === keyToRemove) {
    return removeKeyFromState(state, parentKey)
  } else {
    return removeKeyFromState(state[parentKey], keyToRemove)
  }
}

export function removeItemFromArray(items, index) {
  return [...items.slice(0, index), ...items.slice(index + 1, items.length)]
}
